import { apiClient } from "./client";

export async function fetchMe() {
  const res = await apiClient("get", "/me");
  return res.data;
}

// Stamps acceptance of the STINTE STACK confidentiality/acceptable-use
// notice for the signed-in user. See components/TermsGate.jsx.
export async function acceptTerms() {
  const res = await apiClient("post", "/me/accept-terms");
  return res.data;
}
